import $ from "jquery";

// Expose jQuery globally so UMD plugins like react-owl-carousel and magnific-popup can access it
if (typeof window !== "undefined") {
  window.jQuery = $;
  window.$ = $;
}

export default $;

